import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from "../../../classes/api-response";
import { SnackService } from "../../../services/snack.service";
import { Box } from "../../../model/box";
import { BoxesService } from "../../../services/boxes-service";
import { Constants } from "../../../utils/constants";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Contract } from "../../../model/contract";

@Component({
  selector: 'aw-add-boxes-to-contract',
  templateUrl: './add-boxes-to-contract.component.html',
  styleUrls: ['./add-boxes-to-contract.component.scss']
})
export class AddBoxesToContractComponent implements OnInit {

  addBoxesToContractForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  loadingBoxes = false;
  generalError?: ApiResponse;
  entities = Constants.entities;
  boxStatus = Constants.boxStatuses;

  boxes: Box[] = [];
  selectedBoxes?: Box[];
  boxesIds?: number[];

  constructor(
    private boxService: BoxesService,
    private snackService: SnackService,
    private boxesService: BoxesService,
    @Inject(MAT_DIALOG_DATA) public data: Contract,
  ) {

    this.loadingBoxes = true;
    this.boxesService.getAllBoxes([this.boxStatus.onTheShelf]).subscribe(boxes => {
      this.boxes = boxes;
      this.loadingBoxes = false;
    });

    this.addBoxesToContractForm = new UntypedFormGroup(
      {

        boxes: new UntypedFormControl(
          null,
          [Validators.required]
        ),
      }
    );

  }

  _contract = new Contract();

  @Input() set contract(value: Contract) {
    this._contract = merge(new Contract(), value);
  }

  ngOnInit(): void {
  }


  addBoxes(): void {
    this.saving = true;
    this.selectedBoxes?.forEach((box: Box | undefined) => this.boxesIds?.push(<number>box?.id));
    this.boxService.associateBoxes(this._contract?.company?.id, this.selectedBoxes, this._contract?.id)
      .subscribe(
        () => {
          this.saving = false;
          this.snackService.success('Boxes associated!');
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
        });
  }
}
